module.exports = __webpack_public_path__ + "static/media/rolapal_app_icon.f87aefe8.png";